var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex skeleton-container"},_vm._l((5),function(index){return _c('div',{key:index,staticClass:"d-flex flex-column mr-10"},[_c('v-skeleton-loader',{staticClass:"tab",attrs:{"type":"header, text"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }